module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar navbar-default navbar-fixed-bottom footer"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "navbar-collapse collapse",
    attrs: {
      "id": "footer"
    }
  }, [_c('div', {
    staticClass: "navbar-text"
  }, [_vm._v("\n            © 2018. Copyrights by "), _c('router-link', {
    attrs: {
      "to": "/about"
    }
  }, [_c('img', {
    staticStyle: {
      "padding-left": "5px"
    },
    attrs: {
      "width": "80",
      "src": "/assets/img/signature.png"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "navbar-right"
  }, [_c('ul', {
    staticClass: "nav navbar-nav",
    staticStyle: {
      "padding-top": "5px"
    }
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/about"
    }
  }, [_vm._v("About")])], 1), _vm._v(" "), _vm._m(1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav navbar-nav visible-xs-block"
  }, [_c('li', [_c('a', {
    staticClass: "text-center collapsed",
    attrs: {
      "data-toggle": "collapse",
      "data-target": "#footer"
    }
  }, [_c('i', {
    staticClass: "icon-circle-up2"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "mailto:andrei.hirvi@gmail.com"
    }
  }, [_vm._v("Contact")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-671f88fd","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 362
// module chunks = 0